import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { useHistory } from "react-router";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import TenantManager from "../../managers/TenantManager";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompOffSettings, fetchInitializedCompOffs, selectConfigurationSettings, selectInitializedCompOffs } from "../../Redux/Slices/CompOffSlice";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { initializedCOmpoffsColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import InitialiseCompOff from "./InitialiseCompOff";
import { fetchUsers, selectUsers } from "../../Redux/Slices/PayrollSlice";
import { INPUT_TYPE } from "../../constants/Constant";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import ViewToggle from "../common/ViewToggle";
import { DKIcons, DKFilterPopup, DKButton, DKIcon, DKLabel, Toggle, DKSpinner, removeLoader, showToast, TOAST_TYPE, showLoader, showAlert } from "deskera-ui-library"
import { fetchLocationDimentionList, selectLocationDimentionList } from "../../Redux/Slices/LocationListSlice";
import { fetchCustomFields, selectCustomField } from "../../Redux/Slices/CustomFieldsSlice";
import CustomFieldService from "../../services/CustomFieldService";
import { CompoffService } from "../../services/CompOffService";
import { LOCATION_COLUMN_CONFIG } from "./CompOffConstants";
import Table from "../../services/table";
import zeroState from "../../assets/images/zero-state-default.svg";
import { convertDateToJson } from "../../managers/common/CommonUtil";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";



const ManageCompOff = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const history = useHistory();
    const { t } = useTranslation();

    /**Hooks */
    const [compOffsData, setCompOffsData] = useState(initialState);
    const [filterArray, setFilterArray] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [compOffPopupData, setCompOffPopupData] = useState({
        isEdit: false,
        data: {},
        enable: false
    });
    const [filterPopupEnabled, setFilterPopupState] = useState(false);
    const [additionalFilterConditions, setAdditionalFilterConditions] = useState([]);
    const [toggleData, setToggleData] = useState({
        enable: false
    });
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const [isLoading, setLoadingFlag] = useState(true);
    const [usersMapValues, setUsersMapValues] = useState(new Map());
    const [userPopUpData, setUserIdPopup] = useState({
        enable: false,
        iamUserIds: [],
        users: []
    });
    const [gridColumns, setGridColumns] = useState([]);
    const [conditionFilter, setConditionFilter] = useState([]);
    const [reload, setReload] = useState(false);

    /**Selectors */
    const compOffsGridData = useSelector(selectInitializedCompOffs);
    const locationData = useSelector(selectLocationDimentionList);
    const customFieldsData = useSelector(selectCustomField);
    const userList = useSelector(selectUsers);
    const configurationSetting = useSelector(selectConfigurationSettings);


    /**Dispatch */
    const dispatch = useDispatch();

    useEffect(() => {
        loadConfigurationSettings()
    }, [])

    useEffect(() => {
        if (!configurationSetting.isCompOffEnabled) {
            return
        }

        setLoadingFlag(true);
        RouteManager.setPresenter({ props: { ...props, history: history } });
        loadUsersList();
        let { isLocationActive } = getLocationActiveStatus();
        if (isLocationActive) loadLocationDimenionData();
        loadCustomFields({});
        setCurrentPage(1);
        showLoader()
        loadInitializedCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            hideExpiredCompOff: toggleData.enable,
            module: "",
            condition: []
        })

        window.openUsersList = (iamUserIds) => {
            console.log(Utility.decodeJSON(iamUserIds));
            setUserIdPopup({
                enable: true,
                iamUserIds: Utility.decodeJSON(iamUserIds),
                users: usersMapValues
            })
        }

        return () => {
            window.openUsersList = null;
            setCurrentPage(1)
            CompoffService.initailizedApiConfig = null;
        }
    }, [configurationSetting]);
    

    useEffect(() => {
        if (!Utility.isEmpty(userList)) {
            const { users } = userList;
            const usersMap = getUsersMap(users);
            setUsersMapValues(usersMap);
        }
    }, [userList])

    useEffect(() => {
        if (!Utility.isEmptyObject(compOffsGridData)) {
            setLoadingFlag(true);
            // const filterResponse = compOffsGridData.filterResponse;
            const compOffs = compOffsGridData?.data || [];
            const { tenant } = TenantManager.getPeopleTenantData();
            const { customFields } = customFieldsData;
            const functionConfig = getFunctionConfig();

            const rowData = initializedCOmpoffsColumnConfig(
                compOffs,
                functionConfig,
                tenantDetails,
                customFields,
                usersMapValues
            );
            let { isLocationActive } = getLocationActiveStatus();
            // let columnConfig = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_MANAGE_COMP_OFF), TABLES.PEOPLE_MANAGE_COMP_OFF);

            let columnConfig = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_MANAGE_COMP_OFF), TABLES.PEOPLE_MANAGE_COMP_OFF, {}));

            columnConfig = isLocationActive ? updateEmployeeColumnConfig(columnConfig) : columnConfig;
            columnConfig = updateColumnConfigWithCustomField(columnConfig);

            const passingData = {
                columnData: deepClone(columnConfig),
                rowData,
                filter: [],
                originalData: compOffs
            };
            removeLoader();
            setGridColumns(passingData.columnData);
            setIsFilterEnabled(((locationData.length > 0 || locationData?.content?.length > 0) || (customFieldsData?.customFields?.length > 0)));
            setCompOffsData(passingData);
            setTotalPageCount(compOffsGridData.totalPages);
            setCurrentPage(currentPage);
            setTotalCount(compOffsGridData.numberOfRecords);
            setLoadingFlag(false);
        } else {
            const rowData = [];
            let columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_MANAGE_COMP_OFF), TABLES.PEOPLE_MANAGE_COMP_OFF, {}));
            const passingData = {
                columnData: deepClone(columns),
                rowData,
                filter: [],
                originalData: []
            };
            setCompOffsData(passingData);
            setLoadingFlag(false);
        }
    }, [compOffsGridData, locationData, customFieldsData, usersMapValues, reload]);

    const loadConfigurationSettings = async () => {
        try {
            await dispatch(fetchCompOffSettings());
        } catch (err) {

        }
    }

    const loadInitializedCompOffs = async (config) => {
        const timeOut = showDelayedLoader()
        try {
            CompoffService.initailizedApiConfig = config;
            await dispatch(fetchInitializedCompOffs())
        } catch (err) {

        } finally{
            removeLoader()
        }
        removeDelayedLoader(timeOut)
    }

    const getUsersMap = (users) => {
        const map = new Map();
        users?.forEach((u) => {
            map.set(parseInt(u.iamUserId), u);
        })
        return map;
    }

    const loadUsersList = async () => {
        try {
            await dispatch(fetchUsers())
        } catch (err) {

        }
    }

    const loadLocationDimenionData = async () => {
        try {
            await dispatch(fetchLocationDimentionList());
        } catch (err) {
            console.error("Error loading tenant data: ", err);
        }
    };

    const loadCustomFields = async (config) => {
        try {
            config = {
                ...CustomFieldService.apiConfig,
                Module: "compOff",
            };
            CustomFieldService.apiConfig = config;
            await dispatch(fetchCustomFields());
            removeDelayedLoader();
        } catch (err) {
            console.error("Error loading custom fields data: ", err);
        }
    };

    const getLocationActiveStatus = () => {
        let isLocationActive = false;
        const { additionalSettings } = TenantManager.getTenantDetails() || "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;

        return { isLocationActive, locationSettings };
    }

    const updateEmployeeColumnConfig = (columnConfig) => {
        const { isLocationActive, locationSettings } = getLocationActiveStatus();
        const columnName = isLocationActive ? locationSettings?.locationLabel : "";
        const locationColumn = LOCATION_COLUMN_CONFIG;
        const { content } = locationData;
        const dimension = content?.find(l => {
            return l.label == "LOCATION"
        })
        const attributes = dimension ? dimension["attributes"] : []
        const locationOptions = attributes && attributes.map((x) => {
            return {
                id: x.id,
                name: x.value,
                ...x
            };
        });
        locationColumn["name"] = columnName;
        locationColumn["columnCode"] = "location";
        locationColumn["key"] = "location";
        locationColumn["id"] = "location";
        locationColumn["options"] = locationOptions;
        locationColumn["specifier"] = "location"
        columnConfig.push(locationColumn)
        return columnConfig;
    }

    const updateColumnConfigWithCustomField = (columnConfig) => {
        let fieldConfig = customFieldsData?.customFields?.filter(field=>field.isActive) || [];
        fieldConfig?.forEach((c) => {
            let group = {
                name: c.name,
                columnCode: c.id,
                id: c.id,
                key: c.id,
                width: 150,
                editable: false,
                uiVisible: true,
                specifier: "custom_field"
            };
            group = getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldConfigOnType = (group, c) => {
        switch (c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return {
                        id: p,
                        name: p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break; 
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    const getFunctionConfig = () => {
        return {}
    }

    const deleteConfirm = (data) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
            onClick: () => removeLoader()

        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => onDeleteCompOff(data, true),
        },
    ];


    const onDeleteCompOff = (data, isForceDelete) => {
        const { rowData } = data;
        const selectedIds = [rowData?.id];
        const params = {
            forceDelete: isForceDelete,
            ids: selectedIds
        }
        showLoader(t("COMP_OFF_DELETE_IN_PROGRESS"))
        CompoffService.deleteInitialisedCompoffs(params).then((response) => {
            if (!Utility.isEmpty(response.code)) {
                if (response.code === "CO000") {
                    showToast(t("DELETE_INITIALISED_COMP_OFF"), TOAST_TYPE.SUCCESS);
                    setCurrentPage(1)
                    loadInitializedCompOffs({
                        sort_order: "",
                        sort_field: "",
                        page: 1,
                        limit: pageSize,
                        search_string: "",
                        search_field: "",
                        hideExpiredCompOff: toggleData.enable,
                        module: "",
                        condition: conditionFilter
                    })
                    removeLoader();
                } else if (response.code === "CO002") {
                    showAlert(
                        t("COMP_OFF_CONFIRM_DELETE_MSG_HEADER"),
                        t("COMP_OFF_CONFIRM_DELETE_SUB_MSG"),
                        deleteConfirm(data)
                    );
                }
            }
        }, (err) => {
            removeLoader();
            showToast(t("SOMETHING_WENT_WRONG"), TOAST_TYPE.ERROR);
        })
    }

    const onRowEdit = (data) => {
        setCompOffPopupData({
            enable: true,
            data: data.rowData,
            isEdit: true
        })
    }

    const onContextCancel = () => {

    }

    const onCreateNew = () => {
        setCompOffPopupData({
            enable: true,
            data: {},
            isEdit: false
        })
    }

    const onFilter = () => {

    }

    const onPopupClose = (isReload) => {
        setCompOffPopupData({
            enable: false
        })
        if (isReload) {
            setCurrentPage(1)
            loadInitializedCompOffs({
                sort_order: "",
                sort_field: "",
                page: 1,
                limit: pageSize,
                search_string: "",
                search_field: "",
                hideExpiredCompOff: toggleData.enable,
                module: "",
                condition: conditionFilter
            })
        }
    }

    const toggleFilterPopup = (shouldOpen) => {
        setFilterPopupState(shouldOpen ?? !filterPopupEnabled)
        // this.setState((prevState) => ({
        //   needKanbanFilterPopup: shouldOpen ?? !prevState.needKanbanFilterPopup,
        // }));
    };

    const setAdditionalFilter = (data, refresh = false) => {
        // PipelineManager.filterConditions = data?.query || [];
        let payload = getManageFilters(
            data?.query
        );
        setAdditionalFilterConditions(data?.query);
        setConditionFilter(payload);
        setCurrentPage(1);
        loadInitializedCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            hideExpiredCompOff: toggleData.enable,
            module: "",
            condition: payload
        })
        // this.setState(
        //   {
        //     additionalFilterConditions: data?.query || [],
        //     defaultFilter: payload,
        //   },
        //   () => {
        //     this.refreshDealData();
        //   }
        // );
    };

    const getManageFilters = (additionalFilter) => {
        const filter = [];
        const addtionalFilter = deepClone(additionalFilter);
        addtionalFilter.forEach((condition) => {
            filter.push(TableManger.getFilterSubCondition(condition));
        });
        const updatedFilter = updateFilterWithColumnCode(filter)
        // const defaultFilter = this.getDefaultFilter(view, pipeline);
        // if (!Utility.isEmpty(defaultFilter)) {
        //   filter.push(defaultFilter);
        // }
        return updatedFilter;
    };

    const updateFilterWithColumnCode = (filter) => {
        const updatedFilter = [];
        const filterData = deepClone(filter);
        filterData?.forEach((f) => {
            let index = gridColumns.findIndex(g => g.id === f.colId);
            if (index != -1) {
                let group = {
                    ...f,
                    colId: gridColumns[index].columnCode,
                    key: !Utility.isEmpty(gridColumns[index].specifier) ? gridColumns[index].specifier : ""
                }
                switch (gridColumns[index].type) {
                    case INPUT_TYPE.SELECT:
                    case INPUT_TYPE.MULTI_SELECT:
                        group['value'] = (f.value[0]).toString();
                        group['type'] = INPUT_TYPE.DROPDOWN
                        break;
                    case INPUT_TYPE.DATE:
                        console.log(f);
                        group['value'] = convertDateToJson(f.value);
                        group['type'] = gridColumns[index].type;
                        break;    
                    default:
                        group['value'] = (f.value).toString();
                        group['type'] = gridColumns[index].type;
                        break;
                }
                updatedFilter.push(group);
            }
        })
        return updatedFilter;
    }

    const getFilterPopup = () => {
        const filterableColumns = getUpdatedFilterableColumns();

        return (
            <DKFilterPopup
                filterData={[...additionalFilterConditions]}
                headers={filterableColumns}
                onSubmit={(data) => {
                    toggleFilterPopup(false);
                    setAdditionalFilter(
                        { query: data },

                    );
                }}
                onCancel={() => toggleFilterPopup(false)}
            />
        );
    }

    const getUpdatedFilterableColumns = () => {
        return (
            compOffsData.columnData
                ?.filter((obj) => {
                    return (
                        obj.type &&
                        obj.type !== INPUT_TYPE.BUTTON &&
                        obj.type !== INPUT_TYPE.MORE &&
                        (obj.allowFilter ?? true)
                    );
                })
                .map((obj) => {
                    return obj;
                }) || []
        );
    };

    const changeHideExpiredCompOff = () => {
        setToggleData({
            ...toggleData,
            enable: !toggleData.enable
        })
        setCurrentPage(1);
        loadInitializedCompOffs({
            sort_order: "",
            sort_field: "",
            page: 1,
            limit: pageSize,
            search_string: "",
            search_field: "",
            hideExpiredCompOff: !toggleData.enable,
            module: "",
            condition: conditionFilter
        })
    }

    const onUserIdPopClose = () => {
        setUserIdPopup(false);
    }

    const onColumnShift = (data) => {
        let newColumnArray = data;
        Table.shiftColumn(
            newColumnArray.map((column) => column.key),
            TableManger.getTableId(TABLES.PEOPLE_MANAGE_COMP_OFF)
        ).then((data) => {
            getColumns();
        });
        // Table.updateColumnPeople(
        //     columnData,
        //     TableManger.getTableId(TABLES.PEOPLE_MANAGE_COMP_OFF)
        // ).then((data) => {
        //     getColumns();
        // });
    };

    const onColumnUpdate = (data) => {
        let { columnData } = data;
        Table.updateColumnPeople(
            columnData,
            TableManger.getTableId(TABLES.PEOPLE_MANAGE_COMP_OFF)
        ).then((data) => {
            getColumns();
        });
    };

    const getColumns = () => {
        Table.getTable(TableManger.getTableId(TABLES.PEOPLE_MANAGE_COMP_OFF)).then(
            (data) => {
                TableManger.setTableColumns(data, TABLES.PEOPLE_MANAGE_COMP_OFF);
                // loadPayrollForFirstStep(PayrollService.config);
            },
            (err) => { }
        );
    };

    //   const getUpdatedFilterableColumns = () => {
    //     return (
    //       compOffsData.columnData
    //         ?.filter((obj) => {
    //           return (
    //             obj.type &&
    //             obj.type !== INPUT_TYPE.BUTTON &&
    //             obj.type !== INPUT_TYPE.MORE &&
    //             obj.columnCode !== COLUMN_CODE.DEAL.ATTACHMENT &&
    //             (obj.allowFilter ?? true)
    //           );
    //         })
    //         .map((obj) => {
    //           if (
    //             obj.id ===
    //             TableManger.getColumnId(
    //               TABLES.CANDIDATE,
    //               COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
    //             )
    //           ) {
    //             return {
    //               ...obj,
    //               type: INPUT_TYPE.SELECT,
    //               options: PipelineManager.getStagesForCurrentPipeline(),
    //             };
    //           }

    //           return obj;
    //         }) || []
    //     );
    //   };

    const getHeaderSection = () => {
        return (
            <div className="row row-responsive parent-width justify-content-between">
                <div className="row width-auto">
                    {/* {this.pipelines.length !== 0 && (
                  <div className={`row justify-content-between align-items-start ${isMobileWebView() ? "maxwidth-pipeline":"parent-width "}`}>
                    <div
                      className="row justify-content-between p-h-r p-v-s border-m bg-white border-radius-m position-relative cursor-hand  shadow-m"
                      onClick={this.toggleVisibilityOfPipeline}
                      // style={{ width: 150 }}
                    >
                      <DKLabel
                        className={`unselectable ${isMobileWebView() ? "ellipsis":""}`}
                        text={
                          this.pipelines[this.state.selectedPipelineIndex]
                            .pipelineName
                        }
                      />
                      <DKIcon
                        src={DKIcons.ic_arrow_down2}
                        className="ic-s unselectable ml-s"
                      />
                      {this.state.needPipelineListPicker &&
                        this.getPipelineListPicker()}
                    </div>
                  </div>
                )} */}
                    <DKLabel
                        className={`fw-m fs-m unselectable ${isMobileWebView() ? "ellipsis" : ""}`}
                        text={TABLE_DISPLAY_NAME[TABLES.PEOPLE_MANAGE_COMP_OFF]}
                    />



                    {/* {(this.state.refreshKanban && this.state.selectedView === DEAL_VIEW.KANBAN && !isMobileWebView()) && (
                    <DKSpinner className="ml-r" />
                  )} */}
                    {isLoading && <DKSpinner className="ml-r" />}
                </div>
                <div className="">
                    <div className="row">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Toggle
                                className="border-n "
                                isOn={toggleData.enable}
                                onChange={() => { changeHideExpiredCompOff() }}
                            />
                            <DKLabel
                                className="m-v-s ml-s mr-m"
                                text={"Hide Expired Comp Offs"}
                            />
                        </div>

                        { isFilterEnabled &&<div className="row width-auto position-relative kanban-filter-container pr-s">
                            <DKIcon
                                src={DKIcons.ic_filter}
                                className="ic-s bg-white p-s border-m border-radius-m cursor-hand"
                                onClick={() => toggleFilterPopup()}
                            />
                            {additionalFilterConditions?.length ? (
                                <div
                                    className="position-absolute bg-red circle"
                                    style={{
                                        width: 5,
                                        height: 5,
                                        top: 0,
                                        left: 30,
                                    }}
                                ></div>
                            ) : null}
                            {filterPopupEnabled && getFilterPopup()}
                        </div>}
                        {PermissionUtils.hasAccess(MODULE.MANAGE_COMP_OFF,[ACTION.CREATE]) && <div>
                            <DKButton
                                // icon={DKIcons.ic_add}
                                title={!isMobileWebView() ? "+ Initialize Comp Off" : null}
                                className="bg-app text-white border-m shadow-m"
                                onClick={() => {
                                    onCreateNew()
                                }}
                            />
                        </div>}
                    </div>
                </div>
            </div>
        )
    }

    const nevigateToSetting = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.COMP_OFF.CONFIGURE_COMP_OFF)
    }

    return (
        <>
            {!configurationSetting.isCompOffEnabled ? 
            (
                <div className="d-flex justify-content-center parent-width parent-height">
                    <div className="row" style={{ width: "60%" }}>
                        <div className="bg-white p-h-xl pt-r pb-l border-m border-radius-m border-box dashboard-card column align-items-center parent-width">
                            <div>
                                <img className="ic-xxl pt-xxl" src= {zeroState}>
                                </img>
                            </div>
                            <div className="fw-b fs-xl pt-xl">
                                It seems comp-off isn't enabled yet, Please enable to Manage comp-off!
                            </div>
                            <div className="d-flex fs-m fw-r pt-l">
                                <div className="text-app cursor-hand" onClick={nevigateToSetting}>
                                    <u>Click here</u>&nbsp;
                                </div>
                                <div>
                                     to enable
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            ) : (
                <>
                    {getHeaderSection()}
                    <div className="column parent-width flex-1">
                        <div className="column parent-width mb-s position-relative flex-1">
                            <DataGridHolderPayroll
                                tableName={TABLES.PEOPLE_MANAGE_COMP_OFF}
                                displayTableName={""}
                                allowColumnEdit={true}
                                allowColumnDelete={true}
                                allowColumnShift={true}
                                allowSearch={false}
                                allowFilter={false}
                                allowColumnAdd={false}
                                onRowDelete={(data) => onDeleteCompOff(data, false)}
                                onRowEdit={(data) => {
                                    onRowEdit(data);
                                }}
                                onCancelContext={() => {
                                    onContextCancel();
                                }}
                                // refresh={refresh}
                                addButtonConfig={[]}
                                // onSelection={(data)=>{
                                //   selectedRow = data
                                // }}
                                allowDataExport={false}
                                gridData={compOffsData}
                                // onSearch={onSearch}
                                // onColumnAdd={newColumnAdded}
                                onFilter={onFilter}
                                filter={filterArray}
                                // onRowAdd={onRowAdd}
                                onPaginationClick={(requestedPageNumber) => {
                                    const config = {
                                        ...CompoffService.initailizedApiConfig,
                                        page: requestedPageNumber,
                                    };
                                    setCurrentPage(requestedPageNumber)
                                    loadInitializedCompOffs(config);
                                }}
                                currentPage={currentPage}
                                totalPageCount={totalPageCount}
                                isActionEnabled={true}
                                contextMenu={true}
                                isMenuVisible={false}
                                allowRowEdit={PermissionUtils.hasAccess(MODULE.MANAGE_COMP_OFF,[ACTION.EDIT])}
                                showContextEdit={false}
                                onColumnUpdate={onColumnUpdate}
                                // onColumnShift={onColumnShift}
                                onColumnShift={(data)=> setReload(!reload)}
                                module={MODULE.MANAGE_COMP_OFF}
                            // onView = {(data) => onView(data)}
                            // onSort={(data)=>{onSort(data)}}
                            // onRowUpdate={(data) => {onColumnRowUpdate(data)}}
                            />
                        </div>
                    </div>
                </>
            )

            }
            
            {compOffPopupData.enable && <InitialiseCompOff isEdit={compOffPopupData.isEdit} data={compOffPopupData.data} onClose={(isReload) => onPopupClose(isReload)} />}
            { userPopUpData.enable && (
                <>
                    <div className=" transparent-background">
                        <div className="p-h-r pt-r pb-m popup-window custom-popup-outer" style={{ padding: 0, maxWidth: "25%", width: "100%", overflow: "hidden" }} >
                            
                                <div className="row justify-content-between p-h-m p-v-s bg-gray2">
                                    <DKLabel text={"Comp off is Applicate to"} className="fs-l fw-m" />
                                    <DKButton icon={DKIcons.ic_close} onClick={() => onUserIdPopClose(false)} />
                                </div>
                                <div
                                    className=" parent-width p-m custom-popup-body"
                                >
                                    {userPopUpData.iamUserIds.map((i, index) => {
                                        return (
                                            <>
                                                <div className="pb-s">
                                                    <div className="row fs-m">
                                                        <div>{`${index + 1}. ${usersMapValues.get(i).firstName} ` + `${usersMapValues.get(i).lastName}`}</div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                </>
            )}
        </>
    )
}

export default ManageCompOff;